var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      [
        _vm.purchase.actions.supplier.contract === "sign"
          ? [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("fl44-unknown-volume-supplier-sign-contract-button", {
                        attrs: { purchase: _vm.purchase },
                        on: {
                          refresh: function ($event) {
                            return _vm.$emit("refresh")
                          },
                        },
                      }),
                      _c("fl44-unknown-volume-sign-decline-contract-button", {
                        staticClass: "ml-2",
                        attrs: { "purchase-item": _vm.purchase },
                        on: {
                          refresh: function ($event) {
                            return _vm.$emit("refresh")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.purchase.actions.supplier.can_store_disagreement
                ? [
                    _c("text-header", [
                      _vm._v("Согласование разногласий по контракту"),
                    ]),
                    _c(
                      "b-overlay",
                      {
                        attrs: {
                          show: _vm.isDataSending,
                          opacity: "0.6",
                          rounded: "",
                          "spinner-small": "",
                          "spinner-variant": "primary",
                        },
                      },
                      [
                        _c("form-row-contract-upload", {
                          attrs: {
                            disabled: !_vm.$store.getters.getCanSign,
                            "label-cols-lg": 3,
                            v: _vm.$v.form.attachment,
                            title: "Протокол разногласий",
                          },
                          model: {
                            value: _vm.form.attachment,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "attachment", $$v)
                            },
                            expression: "form.attachment",
                          },
                        }),
                        _c("form-row-edit-textarea", {
                          attrs: {
                            v: _vm.$v.form.comment,
                            label: "Комментарий",
                          },
                          model: {
                            value: _vm.form.comment,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "comment", $$v)
                            },
                            expression: "form.comment",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-overlay",
                      {
                        attrs: {
                          show: _vm.isDataSending,
                          opacity: "0.6",
                          rounded: "",
                          "spinner-small": "",
                          "spinner-variant": "primary",
                        },
                      },
                      [
                        _c(
                          "b-btn",
                          {
                            staticClass: "mr-2",
                            attrs: {
                              disabled:
                                !_vm.$store.getters.getCanSign ||
                                _vm.$v.$invalid,
                              variant: "custom-green",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showDisagreementModal = true
                              },
                            },
                          },
                          [_vm._v("Подписать и отправить протокол разногласий")]
                        ),
                      ],
                      1
                    ),
                    !_vm.$store.getters.getCanSign
                      ? [
                          _vm.$store.getters.getLoginType === "cert"
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                },
                                [
                                  _vm._v(
                                    " Для действия требуется загрузить/заменить МЧД на странице: "
                                  ),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "green-link",
                                      attrs: {
                                        to: { name: "CabinetUserProfile" },
                                      },
                                    },
                                    [_vm._v("Данные учетной записи")]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                },
                                [
                                  _vm._v(
                                    "Подписание возможно только при авторизации при помощи ЭЦП"
                                  ),
                                ]
                              ),
                        ]
                      : _vm._e(),
                    _vm.form.attachment
                      ? _c("sign-file-modal", {
                          attrs: {
                            attachment: _vm.form.attachment,
                            show: _vm.showDisagreementModal,
                            title:
                              "Отправка подписанного протокола разногласий",
                            "is-sending": _vm.isDataSending,
                          },
                          on: {
                            close: function ($event) {
                              _vm.showDisagreementModal = false
                            },
                            submit: _vm.storeSignedDisagreement,
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ]
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }